import Router, { routes } from '../../routes/Router'
import { cleanUpRouteParams } from '../../helpers/RouteHelpers'

export type TagParams = {
  slug?: string | string[]
  page?: string | string[]
  type?: string | string[]
}

export const getTagUrl = (params: TagParams): string => {
  const cleanParams = cleanUpRouteParams(params)

  if (cleanParams?.type) {
    if (cleanParams?.page) {
      return Router.getRouteUrl(routes.tagTypePage, cleanParams)
    }
    return Router.getRouteUrl(routes.tagType, cleanParams)
  }
  if (cleanParams?.page) {
    return Router.getRouteUrl(routes.tagPage, cleanParams)
  }
  return Router.getRouteUrl(routes.tag, cleanParams)
}
